import React, { useCallback, useEffect, useState } from 'react'
import { FaEdit, FaTrash } from 'react-icons/fa'
import { ModalStyles, tbodyBlogCategory, theadBlogCategory } from '../../../components/data/StaticData'
import Table from '../../page-essential/Table'
import Modal from 'react-modal';
import AddTranslationsBlogCategory from './AddTranslations-BlogCategory';
import { GrClose } from 'react-icons/gr';
import DeleteAlert from '../../page-essential/DeleteAlert';
import { useFetch } from '../../../hooks/UseFetch';

type langType = {
    id: string,
    lang_code: string,
    lang_type: string,
    lang: string,
}
type BlogCateogryType = {
    id: string,
    category: string,
    lang: string,
    lang_code: string
}
const TabViewBlogCategory = () => {
    // logic : add lang type in language table 
    // const lang = [{
    //     id: '1',
    //     lang_code: 'Eng',
    //     lang_type: 'primary',

    // }, {
    //     id: '2',
    //     lang_code: 'Frn',
    //     lang_type: 'secondary',


    // }
    // ]

    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [editModalOpen, setEditModalOpen] = React.useState(false);
    const [dltModalOpen, setDltModalOpen] = React.useState(false);
    const [lang, setLang] = useState<[langType]>()
    console.log(lang)
    // console.log("bc", abc)
    // const [lang, setLang] = useState<langType[]>();
    const [langFilter, setLangFilter] = useState({
        id: '',
        lang_code: '',
        lang_type: ''
    })
    const { errMsg, loading, data } = useFetch(`${process.env.REACT_APP_API}/blogCategory/findAll`)

    const fetchLang = useFetch(`${process.env.REACT_APP_API}/lang/findAll`);

    useEffect(() => {
        const primaryLanguage = lang?.find((item) => {
            return item?.lang_type === 'primary'
        }) as langType
        setLangFilter(primaryLanguage)
        if (fetchLang?.data?.languages) {
            setLang(fetchLang.data.languages)

        }

        // setLang(fetchLang?.data?.languages)

    }, [])
    return (
        <div>
            <div className="mt-8 mb-5 flex items-center space-x-2">
                <div className="flex items-center space-x-2">
                    {lang?.map((item, i) => (
                        <p key={i} className={`${langFilter.lang_code === item.lang_code ? 'bg-white text-primary-base py-1 px-2 rounded cursor-pointer border border-primary-dark-600 text-sm font-medium' : 'bg-gray-100 py-1 px-2 rounded cursor-pointer hover:bg-gray-200 text-sm'}`} onClick={() => setLangFilter({ id: item.id, lang_code: item.lang_code, lang_type: item.lang_type })}>
                            {item.lang_code}
                        </p>
                    ))}
                </div>
                <p className="font-medium text-gray-600">| {data?.length} Results by language</p>

            </div>
            <Table thead={theadBlogCategory} >
                {data?.map((item: BlogCateogryType, i: number) => (
                    <tr key={item.id} className='bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600'>
                        <td className="py-4 px-6">
                            {i + 1}
                        </td>
                        <th scope="row" className="py-4 px-6 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                            {item.category}
                        </th>
                        <td className="py-4 px-6">
                            {item.lang}
                        </td>
                        <td className="flex items-center py-4 px-6 space-x-3">
                            {langFilter?.lang_type === 'primary' &&
                                <p className="font-medium text-primary-base hover:underline cursor-pointer" onClick={() => setIsOpen(true)}>Add Translations</p>
                            }
                            <p className="font-medium text-blue-600 dark:text-blue-500 hover:underline cursor-pointer" onClick={() => setEditModalOpen(true)}>
                                <FaEdit />
                            </p>
                            <p className="font-medium text-red-600 dark:text-red-500 hover:underline cursor-pointer" onClick={() => setDltModalOpen(true)}>
                                <FaTrash />
                            </p>
                        </td>
                    </tr>
                ))}
            </Table>

            {/* Modals section  */}
            <Modal
                isOpen={modalIsOpen}
                style={ModalStyles}
                contentLabel="Example Modal"
            >

                <AddTranslationsBlogCategory isModalOpen={setIsOpen} />
            </Modal>

            <Modal
                isOpen={editModalOpen}
                style={ModalStyles}
                contentLabel="Example Modal"
            >
                <AddTranslationsBlogCategory isModalOpen={setEditModalOpen} />
            </Modal>

            <Modal
                isOpen={dltModalOpen}
                style={ModalStyles}
                contentLabel="Example Modal"
            >
                {/* <DeleteAlert setModalOpen={setDltModalOpen} /> */}
            </Modal>

        </div >
    )
}

export default TabViewBlogCategory